import React from 'react'

export default function GameDetailsFooter({game, onClose, onCancel, onConfirm, onUpdateWithFacility, onPreBook}) {
  const confirmedWithFacilityText = game.confirmed_with_facility ? 'Unconfirm with Facility' : 'Confirmed with Facility'
  const confirmedWithFacilityClass = 'btn btn-blue clickable' + (game.confirmed_with_facility ? ' inactive' : '')

  const confirmedText = game.approved ? 'Unconfirm Reservation' : 'Confirm Reservation'
  const confirmedClass = 'btn btn-success clickable' + (game.approved ? ' inactive' : '')

  const preBookedText = game.pre_booked ? 'Un-Book' : 'Pre-Book'
  const preBookedClass = 'btn btn-purple clickable' + (game.pre_booked ? ' inactive' : '')

  return <div className='game-footer-buttons'>
    <div className='confirm-button'>
      <a className={confirmedClass} onClick={onConfirm}>
        {confirmedText}
      </a>
    </div>
    <div className='other-buttons'>
      <a className='btn btn-danger clickable' onClick={onCancel}>Cancel game</a>
      <a className={confirmedWithFacilityClass} onClick={onUpdateWithFacility}>
        {confirmedWithFacilityText}
      </a>
      <a className={preBookedClass} onClick={onPreBook}>{preBookedText}</a>
      <button className='btn btn-default' type='button' onClick={onClose}>Close</button>
    </div>
  </div>
}
